import React from 'react'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'

import Loader from './Loader'

import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';

import { withStyles } from '@material-ui/core/styles';
import {table as styles} from './Mui/styles';
import DownloadCertIcon from './Mui/DownloadCertIcon';

import Icon from '@material-ui/core/Icon';

// import CustomDialog from './inputs/CustomDialog'
import InstaTable from './InstaTable'

import {
  tests_index,
  preferences_index,
  templates_select,
  reset_test,
  clear_test,
  get_test,
  get_test_report,
  set_path,
  tests_xlsx,
  coupons_select,
  campaign_select,
} from '../actions'

import {
  is_logged_on,
  is_validating,
  capitalize
 } from "../helpers"

const mapStateToProps = state => {
  const { items, pagination, totals, fetching, fetched } = state.test
  return {
    fetching,
    fetched,
    tests: items,
    pagination,
    totals,
    current_user: state.auth.current_user.data,
    skills: state.skill.items,
    levels: state.preference.levels,
    templates: state.template.select_items,
    coupons: state.coupon.select_items,
    campaigns: state.voucher.campaigns,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getTests: (page=1, per_page=10, filters={}, sort='', order='') => dispatch( tests_index(page, per_page, filters, sort, order) ),
    getTest: id => dispatch( get_test(id) ),
    getCoupons: () => dispatch( coupons_select() ),
    getTestReport: (id, variant="default") => dispatch( get_test_report(id, variant) ),
    getPreferences: () => dispatch( preferences_index() ),
    resetTest: () => dispatch( reset_test() ),
    clearTest: () => dispatch( clear_test() ),
    setPath: path => dispatch( set_path(path) ),
    getTemplates: () => dispatch( templates_select() ),
    testsXLSX: (filters, sort, order) => dispatch ( tests_xlsx(filters, sort, order) ),
    getCampaigns: () => dispatch( campaign_select() ),
  }
}

class ConnectedTestsIndex extends React.Component {
  state={
    current_test: null,
    current_template: null,
    current_version: null,
    showPreviewTest: false,
    showPreviewTemplate: false,
    current_view: 'all',
    merge_filters: {},
    init_filters: {},
    filters: {},
    sort: '',
    order: '',
    mounted: false
  }

  fieldGetter(field, item, instate) {
    // const { active, locked, confirmed } = item
    // const state = {
    //   ...instate,
    //   filters: {
    //     ...instate.filters,
    //     ...this.state.merge_filters,
    //     // type: this.props.userbase,
    //   }
    // }
    let renderText
    if (field === "created_at" || field === "taken") {
      renderText = new Date(item[field]).toLocaleDateString()
    } else if ( field === "status" ) {
      renderText = this.statusIcon(item.status)
    } else if (field === 'id') {
      renderText = <Link to='' className="test_results_link" title="Preview Instance" onClick={ e=> {
        e.preventDefault()
        this.showPreview(item.id)
      }}>{item.id}</Link>
    } else if (field === 'coupon') {
      renderText = item[field]
    } else if (field === 'duration') {
      renderText = item.duration
    } else if ( ["Grammar", "Vocabulary", "Reading", "Listening"].indexOf(field) > -1) {
      renderText = item.competency_levels ? item.competency_levels[field] : ''
    } else if (field === 'user') {
      renderText = this.props.current_user.role === 'admin' ? (
        <Link to={`/users/${item.buser_id}/edit`} className="test_results_link" title="Edit User" target="_blank" onClick={e => {
          e.stopPropagation()
        }}>
          <div className="td-user-email">{item.user_email}</div>
          <div className="td-user-name">{item.user_name}</div>
        </Link>
      ) : (
        <React.Fragment>
          <div className="td-user-email">{item.user_email}</div>
          <div className="td-user-name">{item.user_name}</div>
        </React.Fragment>
      )
    } else if (field === "actions" ) {
      renderText = (
        <React.Fragment>
          { (item.status === 'completed' || item.status === 'timeout') && this.certificateLink(item) }
          {
            // { (item.status === 'completed' || item.status === 'timeout') && this.reportLink(item) }
            // { (item.status === 'completed' || item.status === 'timeout') && this.reportLevelsLink(item) }
            // {
            //   // (item.status === 'completed' || item.status === 'timeout') && this.resultsLink(item)
            // }
          }
        </React.Fragment>
      )
    } else {
      renderText = item[field] ? capitalize(item[field]) : ''
    }
    return renderText
  }

  componentWillMount() {
    const { getTests, getPreferences, getTemplates, getCoupons, getCampaigns, templates, levels, skills, coupons, setPath } = this.props
    setPath('testresults')
    if ( !templates || templates.length === 0 ) {
      getTemplates()
    }
    if ( !coupons || coupons.length === 0 ) {
      getCoupons()
      getCampaigns()
    }
    if ( !skills || !levels || skills.length === 0 || levels.length === 0 ) {
      getPreferences()
    }
    // Manage Redirections
    let initFilters
    if (this.props.location && this.props.location.state && this.props.location.state.template_id) {
      getTests(1, 10, {template: this.props.location.state.template_id})
      initFilters = {...this.state.initFilters, template: this.props.location.state.template_id }
      this.setState({ initFilters: initFilters, filters: initFilters })
    } else if (this.props.location && this.props.location.state && this.props.location.state.coupon_id) {
      getTests(1, 10, {coupon: this.props.location.state.coupon_id})
      initFilters = {...this.state.initFilters, coupon: this.props.location.state.coupon_id }
      this.setState({ initFilters: initFilters, filters: initFilters })
    } else if (this.props.location && this.props.location.state && this.props.location.state.user) {
      getTests(1, 10, {search: this.props.location.state.user})
      initFilters = {...this.state.initFilters, search: this.props.location.state.user }
      this.setState({ initFilters: initFilters, filters: initFilters })
    } else {
      getTests()
    }
  }

  componentWillUnmount() {
    this.props.resetTest()
  }

  componentDidUpdate(prevProps, prevState) {
    if (!this.state.mounted) {
      if (prevProps.fetching && !this.props.fetching && this.props.fetched) {
        this.setState({mounted: true})
      }
    }
  }


  getGlobalFilters(filters, sort, order) {
    this.setState({filters: filters, sort: sort, order: order})
  }

  certificateLink = (test) => {
    const {id} = test
    return (
      <Link to="" className="action-btn svgcerticon" title="Download Certificate" onClick={e=>{
        e.preventDefault()
        this.props.getTestReport(id, "certificate")
      }}>
        <DownloadCertIcon style={{color: 'rgba(0,0,0,0.87)', fontSize: '18px'}} />
      </Link>
    )
  }

  handleStatus = value => {
    if (value === 'all') {
      this.setState({merge_filters: {}})
    } else {
      this.setState({merge_filters: {status: value}})
    }
    this.setState({current_view: value})
  }

  hideDialog() {
    this.setState({showDialog: false, showPreviewTest: false, showPreviewTemplate: false})
  }

  statusIcon = status => {
    const icons = {
      completed: 'check_circle',
      incomplete: 'error',
      timeout: 'watch_later',
      idle: 'pause_circle_filled',
      running: 'play_circle_filled',
      abandoned: 'not_interested',
    }
    return (icons[status] !== undefined) ? <Icon style={{color: 'rgba(0,0,0,0.87)', fontSize: '16px'}} title={status === 'abandoned' ? 'Dropped' : capitalize(status)}>{icons[status]}</Icon> : ''
  }

  showPreview = id => {
    this.props.resetTest()
    this.setState({showPreviewTemplate: false, showPreviewTest: true, current_test: id, current_template: null, current_version: null})
  }

  showPreviewTemplate = (version, id) => {
    this.setState({showPreviewTemplate: true, showPreviewTest: false, current_version: version, current_template: id, current_test: null})
  }

  headerButton = (filters, sort, order) => {
    // return ''
    return (
      <Hidden smDown>
        <a href='' style={{float: 'right'}} onClick={e => {
          e.preventDefault()
          this.props.testsXLSX(filters, sort, order)
        }}>
          Download XLSX
        </a>
      </Hidden>
    )
  }

  render() {
    if ( !is_logged_on() && !is_validating() ) {
      return <Redirect to="/" />
    }

    const { pagination, skills, levels, coupons, totals, tests, fetching, campaigns } = this.props

    if (!this.state.mounted) {
      return <Loader />
    }

    const columns = [
      { id: 'id', disablePadding: true, label: 'ID', disableSort: true },
      { id: 'taken', disablePadding: true, label: 'Date' },
      { id: 'status', disablePadding: true, label: 'Status', disableSort: true },
      { id: 'user', disablePadding: true, label: 'User' },
      { id: 'coupon', disablePadding: true, label: 'Coupon', disableSort: true },
      { id: 'campaign', disablePadding: true, label: 'Campaign' },
      { id: 'template_name', disablePadding: true, label: 'Template', disableSort: true },
      { id: 'skill', disablePadding: true, label: 'Skill', disableSort: true },
      { id: 'level', disablePadding: true, label: 'Level' },
      { id: 'Grammar', disablePadding: true, label: 'Grammar' },
      { id: 'Vocabulary', disablePadding: true, label: 'Vocabulary' },
      { id: 'Reading', disablePadding: true, label: 'Reading' },
      { id: 'Listening', disablePadding: true, label: 'Listening' },
      { id: 'actions', disablePadding: true, label: 'Actions', disableSort: true },
    ]

    const filterControls = [
      { name: "skill", filter_type: "select", valueField: "name", collection: skills  },
      { name: "coupon", filter_type: "select", valueField: "name", collection: coupons },
      { name: "campaign", filter_type: "select", valueField: "name", collection: campaigns },
      { name: "level", filter_type: "select", valueField: "name", collection: levels.map( l => { return {id: l.rank, name: l.name}}) },
      { name: "search", filter_type: "search" },
      { name: "taken", filter_type: "date" },
    ]
    const statuses = [
      { name: "all", label: "All", value: totals.all },
      { name: "completed", label: "Completed", value: totals.completed },
      { name: "incomplete", label: "Incomplete", value: totals.incomplete },
      { name: "timeout", label: "Timeout", value: totals.timeout },
      { name: "abandoned", label: "Dropped", value: totals.abandoned },
      { name: "idle", label: "Idle", value: totals.idle },
      { name: "running", label: "Running", value: totals.running },
    ]

    return (
      <div id="users-wrapper" className={fetching ? "fetching-list" : ''}>
        <div className="d-flex justify-content-between mb-40">
          <Typography className=" fw-bold h4">
            {this.props.header || "Instance Results"}
          </Typography>
        </div>

        <InstaTable
          statuses={statuses}
          columns={columns}
          filterControls={filterControls}
          rows={tests}
          pagination={pagination}
          userRole={'client'}
          merge_filters={{
            ...this.state.merge_filters,
            // type: this.props.userbase,
          }}
          search={true}
          placeholders="ID, User, Template"
          getGlobalFilters={this.getGlobalFilters.bind(this)}
          init_filters={this.state.initFilters}
          rowGetter={this.props.getTests.bind(this)}
          fieldGetter={this.fieldGetter.bind(this)}
          current_view={this.state.current_view}
          handleStatus={this.handleStatus.bind(this)}
          clearItem={this.props.clearTest.bind(this)}
          previewItem={ function(){ return }}
          classPrefix="test"
          addClassField="status"
          headerButton={this.headerButton.bind(this)}
        />

      </div>
    )
  }
}

const TestsIndex = connect(mapStateToProps, mapDispatchToProps)(ConnectedTestsIndex)

export default withStyles(styles)(TestsIndex)



// WEBPACK FOOTER //
// ./src/js/components/TestsIndex.js